<template>
  <v-app>
    <!-- Simple Top Nav (Dark Mode Only) -->
    <v-app-bar
        flat
        color="#121212"
        elevation="1"
        app
        dark
    >
      <v-toolbar-title class="font-weight">
             Ali Bayani
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn text href="#home">Home</v-btn> -->
      <!-- <v-btn text href="#publications">Publications</v-btn> -->
      <!-- Removed CV link completely -->
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* Global Dark Mode Styles */
body, html {
  margin: 0;
  padding: 0;
  font-family: 'InterVariable', sans-serif;
  background-color: #121212;
  color: #ffffff;
}

::-webkit-scrollbar {
  width: 0;
}
</style>